import request from '@/utils/request2'

// 待办服务列表
export const getTodoServiceList = () => request({
  url: '/workOnLine/employ/getTodoEmployList',
  method: 'get'
})
// 已办服务列表
export const getDoneServiceList = () => request({
  url: '/workOnLine/employ/getFinishedEmployList',
  method: 'get'
})
// 待办申请列表
export const getTodoApplyList = (data) => request({
  url: '/workOnLine/employ/getTodoApplyList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 已办申请列表
export const getDoneApplyList = (data) => request({
  url: '/workOnLine/employ/getFinishedApplyList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 审批详情
export const getCheckedDetail = (applyId) => request({
  url: '/workOnLine/employ/getEmployApplyInfo',
  method: 'get',
  params: { applyId }
})
// 同意申请
export const agreeApply = (data) => request({
  url: '/workOnLine/employ/completeEmployApply',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 拒绝申请
export const rejectApply = (data) => request({
  url: '/workOnLine/employ/rejectEmployApply',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})